import { StyleSheet } from 'react-native';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Alerts } from 'src/theme-v2/colors';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Spacing } from 'src/theme-v2/spacing';
import { Stroke } from 'src/theme-v2/stroke';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  hoverTooltipContainer: {
    borderRadius: CornerRadius.Large,
  },
  hoverTooltipContentWrapper: {
    ...textLatoStyleDS.BodyRegularSm,
    color: ColorTypography.TextColorSecondary,
    padding: Spacing.Compact,
    minWidth: 300,
  },
  pressTooltipContainer: {
    borderRadius: CornerRadius.Large,
  },
  tooltipButtonPressable: {
    borderRadius: CornerRadius.Full,
  },
  tooltipButton: {
    gap: Spacing.Condensed,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderWidth: Stroke.StrokeThickness.StrokeThicknessDefault,
    borderRadius: CornerRadius.Normal,
    paddingHorizontal: Spacing.Condensed,
    paddingVertical: Spacing.Condensed,
    borderColor: 'transparent',
  },
  tooltipButtonActive: {
    backgroundColor: Alerts.Green100,
  },
  tooltipButtonText: {
    ...textLatoStyleDS.BodyBoldMd,
    color: Alerts.Green800,
  },
});
